query GET_OWNER ($id: UUID!) {
  owner (id: $id) {
    name
    id
    facility {
      id
      name
      description
      maxBookingWindow
      markedAsSoldOut
      updatedDatetime
      status
      teamMembers {
        id
        email
        firstName
        lastName
        phone
        role
        status
        facilities {
          id
          name
        }
      }
      images {
        id
        file
        displayOrder
        isThumbnail
        name
      }
      lots {
        id
        name
        spots
        status
        longitude
        latitude
        floor
        maxHeightSupported
        hasSpaceForBiggerVehicles
        parkerInstructions
        description
        isApproved
        tags {
          id
          name
        }
        facility {
          id
          name
        }
        parkingSchedules {
          id
          name
          appliesToDays
          price
          priceHourly
          priority
          startDate
          endDate
          notes
          spots
          blackoutDates
          openingTime
          closingTime
          priceOvernight
          availableReservationTypes
        }
      }
      address {
        address1
        address2
        city
        state
        zipCode
      }
      amenities {
        id
        description
        iconName
        name
      }
    }
  }
  reservations (ownerId: $id) {
    count
    items {
      id
      checkoutDatetime
      checkinDatetime
      status
      isRental
      type
      topups {
        amount
      }
      lot {
        name
      }
      order {
        amount
        finalAmount
        receipt
      }
      parker {
        email
        phone
        user {
          avatar
          firstName
          lastName
        }
      }
      vehicle {
        color
        model
        make
        licenseNumber
      }
    }
  }
}
